
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 8.25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"fill":"#1cd8aa","d":"M2.92 8.23a.18.18 0 01-.09-.06L.08 5.42A.27.27 0 010 5.23.3.3 0 01.08 5a.27.27 0 01.19 0 .3.3 0 01.2 0L3 7.59 10.53.08a.3.3 0 01.2-.08.27.27 0 01.19.08.28.28 0 01.08.2.27.27 0 01-.08.19l-7.7 7.7-.09.06-.13.02z","data-name":"Layer 1"}})])])
          )
        }
      }
    